export function makeSingleArgActionCreator(type) {
    return function(arg='') {
        const action = { type, payload: arg };
        return action;
    }
}
